export const getBolgheriData = () => ({
  name: "Bolgheri",
  country: "Italie",
  region: "Toscane",
  description: "Bolgheri est une appellation moderne de la Toscane, célèbre pour ses vins rouges de style bordelais avec des cépages internationaux.",
  type: "subregion",
  mapAreas: [
    { region: "Bolgheri", x: 46, y: 43, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "1,200 ha",
    production: "50,000 hl",
    wineries: "40+ domaines",
    villages: "3 communes",
    exportPercentage: "85%"
  },
  characteristics: {
    climate: "Climat méditerranéen tempéré, influence maritime",
    soil: "Sols argilo-calcaires, galets roulés",
    viticulture: "Viticulture moderne, rendements limités"
  },
  wineStyles: {
    red: "Rouges puissants et structurés, style bordelais, grande capacité de garde"
  },
  history: "Bolgheri est née dans les années 1970 avec Sassicaia, révolutionnant la viticulture toscane avec des cépages internationaux.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine toscane",
  grapeVarieties: [
    {
      name: "Cabernet Sauvignon",
      percentage: "50%",
      description: "Cépage principal de Bolgheri, produisant des vins structurés et complexes",
      characteristics: "Structuré, tanins fermes, notes de cassis et de cèdre",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Merlot",
      percentage: "30%",
      description: "Cépage d'assemblage, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Cabernet Franc",
      percentage: "15%",
      description: "Cépage d'assemblage, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, tanins fins, notes de violette",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Petit Verdot",
      percentage: "5%",
      description: "Cépage d'assemblage, apportant couleur et structure",
      characteristics: "Coloré, structuré, notes d'épices",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ]
}); 